import React from 'react'
import { useIntl } from 'react-intl'
import styled from '@emotion/styled'
import { LinearProgress } from '@mui/material'
import { H3 } from '../../../layouts/TextStyles'
import { courseApiSlice } from '../../../features/course/courseSlice'
import AnalyticsTable from './components/AnalyticsTable'
import Sentinel from '../../../components/infiniteScroll/Sentinel'
import { usePaginatedList } from '../../../app/hooks/usePaginatedList'
import { ui } from '../../../utils/uiTokens'

const AnalyticsPage = () => {
    const { formatMessage } = useIntl()
    const [fetchAnalytics] = courseApiSlice.useLazyFetchAnalyticsQuery()

    const { rows, isLoading, loadedPages, sentinelRef } = usePaginatedList(
        (page, size) => fetchAnalytics({ page, size }).unwrap(),
        [],
    )

    return (
        <Wrapper>
            <Content>
                <Header>
                    <Title>
                        <H3> {formatMessage({ id: 'courseAnalytic' })} </H3>
                    </Title>
                </Header>

                {isLoading && loadedPages === 0 ? (
                    <LinearProgress />
                ) : (
                    <>
                        <AnalyticsTable
                            isFetching={isLoading}
                            analyticsData={rows}
                        />

                        <Sentinel ref={sentinelRef} isLoading={isLoading} />
                    </>
                )}
            </Content>
        </Wrapper>
    )
}

export default AnalyticsPage


const Wrapper = styled.div`
    margin: 10px;
    border-radius: 16px;
`

const Title = styled.div`
    margin-bottom: 20px;
    text-align: left;
    display: flex;
    align-items: center;
`

const Content = styled.div`
    background-color: ${ui.card};
    border-radius: 16px;
    padding: 20px;
    min-height: 80vh;
`

const Header = styled.header`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
`
